//@flow
import { Divider, List, ListItem, ListItemButton, Paper, Toolbar, Typography } from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useTheme } from "@mui/material/styles";
import React, { useMemo } from 'react';
import { useTranslation } from "react-i18next";
import { IMAGE_LOGO } from "../../../../../assets/images";
import CloudDownloadIcon from "../../../../../assets/images/icons/buttons/cloudDownloadIcon";
import { AuthenticatedLink } from "../../../../../components/general/authenticatedLink/authenticatedLink";
import ContentLoader from "../../../../../components/general/contentLoader/contentLoader";
import { FileTypes } from "../../../../../helpers/constants";
import { normalizeGreek } from "../../../../../helpers/normalizeGreek";
import { useExhibition } from "../../../../../hooks/exhibitions/useExhibition";
import { useMultilingualText } from "../../../../../hooks/useMultilingualText";
import useUserData from "../../../../../hooks/user/useUserData";
import { EXHIBITION } from "../../../../../locales/components/namespaces";

const UseFullFiles = (props) => {
	const { t } = useTranslation(EXHIBITION)
	const theme = useTheme()
	const { files, loadingFiles } = useExhibition()
	const { language } = useUserData()
	const { image } = props
	const defaultImage = useMultilingualText(IMAGE_LOGO)
	const fileList = useMemo(() => {
		return (
			files
			.filter((f) => (
				f.type === FileTypes.WelcomePage &&
				f.language === language
			))
			.map((file) => (
				<AuthenticatedLink
					key={file.id}
					url={file.url}
					filename={file.name}
				>
					<ListItem disableGutters>
						<ListItemButton>
							<ListItemIcon sx={{ minWidth: '28px' }}>
								<CloudDownloadIcon stroke={"#647DFF"}/>
							</ListItemIcon>
							<ListItemText>
								<Typography variant={'body1'} sx={{fontWeight: 'bold'}} color={theme.palette.highlight.main}>
									{normalizeGreek(t(file.description && file.description !== '' ?
										file.description : file.name))}
								</Typography>
							</ListItemText>
						</ListItemButton>
					</ListItem>
				</AuthenticatedLink>
			))
		)
	}, [files, language, t, theme.palette.highlight.main])

	return (
		<React.Fragment>
			<Paper
				sx={{
					px: 2,
					p: 4,
					border: '1px solid',
					borderColor: theme.palette.primary[200],
					borderRadius: '12px'
				}}
				variant={"outlined"}
			>
				<Toolbar disableGutters variant={"dense"}>
					<Typography variant="h5" fontWeight={700}>
						{t('Useful Files')}
					</Typography>
				</Toolbar>
				<Divider
					sx={{ mb: 4, border: '1px solid', borderColor: theme.palette.primary[800] }}/>
				<List sx={{ width: "100%" }} dense>
					<ListItem>
						<img
							style={{
								margin: "auto",
								maxWidth: "100%",
								height: "auto",
								minHeight: {
									md: 240
								},
								objectFit: "contain"
							}}
							src={image ? image : defaultImage}
							alt={'exhibition logo'}
						/>
					</ListItem>
					{files && files.length > 0 ? (
						fileList
					) : (
						<ContentLoader
							loading={loadingFiles}
						/>
					)}
				</List>
			</Paper>
		</React.Fragment>
	)
}

export default UseFullFiles;